"use client";

import React, { useState, useEffect } from "react";

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);
    setError("");
    setSent(false);

    try {
      // In a real application, you would replace this with a backend endpoint.
      // For this example, we'll simulate a successful API call.
      await new Promise(resolve => setTimeout(resolve, 1500));
      setSent(true);
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div
      className="bg-gradient-to-b from-gray-100 to-gray-200 min-h-screen flex items-center justify-center"
      style={{ padding: "2rem 0" }}
    >
      <form
        className="max-w-lg w-full mx-auto rounded-xl shadow-2xl p-8 backdrop-blur bg-white border border-gray-200"
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Logo Image at top center */}
        <div className="flex justify-center mb-6">
          <img
            src="/rec-5.png"
            alt="Gotcha Logo"
            width={120}
            height={120}
          />
        </div>

        <h2 className="text-2xl font-bold mb-4 text-center text-slate-900">
          Contact Us!
        </h2>

        <div className="mb-4">
          <label
            htmlFor="name"
            className="block mb-1 font-semibold text-gray-700"
          >
            Name
          </label>
          <input
            id="name"
            className="w-full rounded-md border border-gray-200 p-2 bg-white text-slate-900 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            disabled={sending}
            autoComplete="name"
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="email"
            className="block mb-1 font-semibold text-gray-700"
          >
            Email
          </label>
          <input
            id="email"
            className="w-full rounded-md border border-gray-200 p-2 bg-white text-slate-900 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            disabled={sending}
            autoComplete="email"
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="message"
            className="block mb-1 font-semibold text-gray-700"
          >
            Message
          </label>
          <textarea
            id="message"
            className="w-full rounded-md border border-gray-200 p-2 bg-white text-slate-900 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            name="message"
            rows={5}
            value={form.message}
            onChange={handleChange}
            required
            disabled={sending}
          />
        </div>

        {error && (
          <div className="mb-4 p-2 rounded text-white bg-red-600">
            {error}
          </div>
        )}

        {sent && (
          <div className="mb-4 p-2 rounded text-white bg-teal-600">
            Thank you! We’ve received your message.
          </div>
        )}

        <button
          type="submit"
          className="w-full font-bold py-2 px-4 rounded transition-all duration-300 text-white bg-gradient-to-r from-teal-600 to-orange-600 hover:from-teal-700 hover:to-orange-700 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={sending}
          aria-busy={sending}
        >
          {sending ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
}